<template>
    <UiValue v-if="this.title" :title="this.title" :value="this.value" :um="this.um" :img="this.img" :updatedAt="this.updatedAt" />
</template>

<script>
import axios from "axios";
import moment from "moment";
import { functions } from "../functions";
import { requestTools } from "../mixins/requestTools.js";
import { appCaller } from "../mixins/appCaller";
import UiValue from '@/components/UiValue';

export default {
    name: "UiValueAutoload",

    props: {
        id: Number
    },

    mixins: [requestTools, appCaller],

    components: {
        UiValue,
    },

    data: function () {
        return {
            tag: "",
            title: "",
            value: "",
            um: "",
            icon: "",
            img: "",
            updatedAt: "",
        };
    },

    created: function () {

    },

    mounted: function () {
        this.loadUi();
    },

    afterCreate: function () { },

    beforeCreate: function () { },

    beforeDestroy: function () {

    },

    methods: {
        loop: async function () {
            this.loadUi();
        },

        loadFromDb: async function (url) {
            const response = await axios.get(url, axios.getHeaders()).catch((err) => {
                return functions.parseCatch(err, this.$appMessages.err404);
            });
            return response.data;
        },

        forceMainUiUpdate() {
            this.mainUi = JSON.parse(JSON.stringify(this.mainUi));
        },

        showMainUiImagCond(image) {
            this.img = image;
        },

        async loadMainUiImageCond() {

            if (!this.id) {
                return;
            }

            if (!this.id || (this.value + "").trim() == "") {
                return;
            }

            const url = process.env.VUE_APP_ROOT_API + "/uicondexec/" + this.id + "/" + this.value;
            const conds = await this.requestGet(url);
            for (let i in conds) {
                const cond = conds[i];
                if (0 === parseInt(cond.isTrue) || cond.image === "") {
                    continue;
                }
                this.showMainUiImagCond(cond.image);
            }
            return "";
        },

        loadUi: async function () {
            const url = process.env.VUE_APP_ROOT_API + "/ui/get/" + this.id;
            const ui = await this.requestGet(url);
            this.title = ui.title;
            this.tag = ui.tag;
            this.value = "" + ui.value;
            this.updatedAt = this.parseDateTime(ui.valueUpdatedAt);
            this.um = ui.dynamicMeasureUnit;
            this.inAlarm = ui.inAlarm;
            this.image = "";
            this.loadMainUiImageCond();
        },

        parseDateTime: function (dateTimeUs) {
            return moment(dateTimeUs).format("DD-MM-Y HH:mm:ss");
        },
    },
};
</script>

<style scoped>
.list-item-value {
    color: #999999;
    font-size: 12px;
}

.v-list-item__title {
    color: #666666;
    font-size: 13px;
}

.sublist.v-list-item .image {
    margin-right: 5px;
}
</style>
